import { Box } from '@mui/material';
import { BracketSeedMatchGameEntity } from 'app/interfaces/entity';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';
import { MatchGameCodeInput } from './MatchGameCodeInput';
import React, { FC, useMemo } from 'react';
import { CodeSourceKey } from './CodeSourceKey';

interface ComponentProps {
  matchGames: BracketSeedMatchGameEntity[];
  sourceKey: CodeSourceKey;
}

export const TournamentMatchGameCodes: FC<ComponentProps> = ({ matchGames, sourceKey }) => {
  const matchGamesWithCodes = useMemo(
    () => matchGames.filter((matchGame) => matchGame[sourceKey]),
    [sourceKey, matchGames]
  );

  if (!matchGamesWithCodes.length) {
    return (
      <Box height="100%" display="flex">
        <EmptyPlaceholder text="No Codes" />
      </Box>
    );
  }

  return (
    <Box>
      {matchGamesWithCodes.map((matchGame) => (
        <MatchGameCodeInput
          key={matchGame.externalId}
          matchGame={matchGame}
          sourceKey={sourceKey}
        />
      ))}
    </Box>
  );
};
